module.exports = __webpack_public_path__ + "static/media/logo1 (2).a5f8f2d6.png";